import Vue from 'vue'

const backendUrl = process.env.VUE_APP_BACKEND_URL

export default class BackendService{
  getBackendUrl(){
    return backendUrl
  }

  /**
   * Login
   */
  login(username, password){
    return Vue.http.post(`${backendUrl}/api/authentication/login`, {username, password})
  }

  resetPassword(email, captcha){
    return Vue.http.patch(`${backendUrl}/api/users/reset-password`, {email, captcha})
  }

  logout(){
    return Vue.http.post(`${backendUrl}/api/authentication/logout`)
  }

  /**
   * Homepage
   */
  getHomepageIntroduction() {
    return Vue.http.get(`${backendUrl}/api/home/introduction`).then((res) => res.body)
  }

  getHomepageIntroductionImages() {
    return Vue.http.get(`${backendUrl}/api/home/introduction/images`).then((res) => res.body)
  }

  updateHomepageIntroduction(text){
    return Vue.http.put(`${backendUrl}/api/home/introduction`, {text})
  }

  addHomepageIntroductionImage(imageFile){
    let formData = new FormData()
    formData.append('image', imageFile)
    return Vue.http.post(`${backendUrl}/api/home/introduction/images`, formData).then((res) => res.body)
  }

  deleteHomepageIntroductionImage(filename){
    return Vue.http.delete(`${backendUrl}/api/home/introduction/images`, {body: {filename}})
  }

  reorderHomepageIntroductionImages(imageOrder){
    return Vue.http.post(`${backendUrl}/api/home/introduction/images/reorder`, {imageOrder})
  }

  getLocations() {
    return Vue.http.get(`${backendUrl}/api/home/locations`).then((res) => res.body)
  }

  /**
   * Locations admin
   */
  listLocations(){
    return Vue.http.get(`${backendUrl}/api/locations`).then((res) => res.body)
  }

  createLocation(location){
    return Vue.http.post(`${backendUrl}/api/locations`, location).then((res) => res.body)
  }

  updateLocation(location){
    return Vue.http.put(`${backendUrl}/api/locations`, location).then((res) => res.body)
  }

  deleteLocation(id){
    return Vue.http.delete(`${backendUrl}/api/locations/${id}`).then((res) => res.body)
  }

  getNextEvents() {
    return Vue.http.get(`${backendUrl}/api/events/list`).then((res) => res.body)
  }

  /**
   * Events admin
   */
  listFutureEvents(){
    return Vue.http.get(`${backendUrl}/api/events/all`).then((res) => res.body)
  }

  createEvent(event){
    return Vue.http.post(`${backendUrl}/api/events`, event)
  }

  updateEvent(event){
    return Vue.http.put(`${backendUrl}/api/events`, event)
  }

  deleteEvent(eventid){
    return Vue.http.delete(`${backendUrl}/api/events/${eventid}`)
  }
  
  getEventDetails(id){
    return Vue.http.get(`${backendUrl}/api/events/get/${id}`).then((res) => res.body)
  }

  /**
   * Game sheets
   */
  getGameDetails(id){
    return Vue.http.get(`${backendUrl}/api/games/get/${id}`).then((res) => res.body)
  }

  createGame(game){
    return Vue.http.post(`${backendUrl}/api/games`, game).then((res) => res.body)
  }

  updateGame(game){
    return Vue.http.put(`${backendUrl}/api/games`, game).then((res) => res.body)
  }

  setGameIcon(gameName, iconFile){
    let formData = new FormData()

    formData.append('image', iconFile)
    return Vue.http.post(`${backendUrl}/api/games/${gameName}/setIcon`, formData).then((res) => res.body)
  }

  addGameImage(gameName, imageFile){
    let formData = new FormData()

    formData.append('image', imageFile)
    return Vue.http.post(`${backendUrl}/api/games/${gameName}/addImage`, formData).then((res) => res.body)
  }

  deleteGameImage(gameName, imageName){
    return Vue.http.delete(`${backendUrl}/api/games/${gameName}/removeImage?name=${imageName}`).then((res) => res.body)
  }

  deleteGame(id){
    return Vue.http.delete(`${backendUrl}/api/games/${id}`)
  }

  listGames(tags){
    return Vue.http.get(`${backendUrl}/api/games/list`).then((res) => res.body)
  }
  
  /**
   * Users admin
   */
  listUsers(){
    return Vue.http.get(`${backendUrl}/api/users`).then((res) => res.body)
  }

  createUser(user){
    return Vue.http.post(`${backendUrl}/api/users`, user)
  }

  updateUser(user){
    return Vue.http.put(`${backendUrl}/api/users`, user)
  }

  deleteUser(email){
    return Vue.http.delete(`${backendUrl}/api/users`, {body: {email}})
  }

  getUserDetails(email){
    return Vue.http.get(`${backendUrl}/api/users?email=${email}`).then((res) => res.body)
  }
  
  /**
   * User profile
   */
  deleteAccount(){
    return Vue.http.patch(`${backendUrl}/api/users/delete-current`)
  }

  changePassword(old, newpass){
    return Vue.http.patch(`${backendUrl}/api/users/change-password`, {old, new: newpass})
  }

  updateData(data){
    return Vue.http.patch(`${backendUrl}/api/users/update-data`, data)
  }

  changeAvatar(imageFile){
    let formData = new FormData()
    formData.append('image', imageFile)
    return Vue.http.post(`${backendUrl}/api/users/update-avatar`, formData).then((res) => res.body)
  }
  
  getData(){
    return Vue.http.get(`${backendUrl}/api/user-data`).then((res) => res.body[0])
  }
  
  getAvatar(user){
    return Vue.http.get(`${backendUrl}/api/user-avatar?email=${user}`).then((res) => res.body)
  }
  
  /**
   * Boards
   */

  getBoardsForEvent(eventId){
    return Vue.http.get(`${backendUrl}/api/boards/${eventId}`).then((res) => res.body)
  }

  createBoard(eventId, board){
    let formData = new FormData()

    formData.append('image', board.image)
    formData.append('name', board.name)
    formData.append('event', eventId)
    formData.append('minPlayers', board.minPlayers)
    formData.append('maxPlayers', board.maxPlayers)
    formData.append('external_link', board.external_link ? board.external_link : '')
    return Vue.http.post(`${backendUrl}/api/boards`, formData).then((res) => res.body)
  }

  updateBoard(board){
    let formData = new FormData()

    if(board.image){
      formData.append('image', board.image)
    }
    formData.append('name', board.name)
    formData.append('id', board.id)
    formData.append('minPlayers', board.minPlayers)
    formData.append('maxPlayers', board.maxPlayers)
    formData.append('external_link', board.external_link ? board.external_link : '')
    formData.append('_method', 'put')
    return Vue.http.post(`${backendUrl}/api/boards`, formData).then((res) => res.body)
  }

  deleteBoard(boardId){
    return Vue.http.delete(`${backendUrl}/api/boards/${boardId}`)
  }

  subscribeToBoard(board){
    const data = {
      action: "subscribe",
      board: board.id || null,
      event: board.event || null,
    }
    return Vue.http.patch(`${backendUrl}/api/boards/subscribe`, data)
  }

  unsubscribeFromBoard(board){
    const data = {
        action: "unsubscribe",
        board: board.id || null,
        event: board.event || null,
      }
    return Vue.http.patch(`${backendUrl}/api/boards/subscribe`, data)
  }
  
}
